import React from 'react';

import { JiraIcon, RovoIcon } from '@atlaskit/logo';
import LabelIcon from '@atlaskit/icon/core/tag';
import PageIcon from '@atlaskit/icon/core/page';
import EmailIcon from '@atlaskit/icon/core/email';
import CommentIcon from '@atlaskit/icon/core/comment';
import LockIcon from '@atlaskit/icon/core/lock-locked';
import PersonIcon from '@atlaskit/icon/core/person';
import CopyIcon from '@atlaskit/icon/core/copy';
import RightArrowIcon from '@atlaskit/icon/core/arrow-right';
import DatabaseIcon from '@atlaskit/icon/core/database';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import FolderIcon from '@atlaskit/icon/core/folder-closed';
import ShieldIcon from '@atlaskit/icon/core/shield';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';

import { getPrimaryColor } from '../../utils/colorUtils.ts';
import { ComponentType } from '../../edit/SmartButtonConfigPanel/templates/templateCardConfigs.tsx';

export const getComponentPreviewIcon = (componentType: string) => {
	switch (componentType) {
		case 'confluence.change-page-status.action':
		case 'confluence.create-page.action':
			return <PageIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.add-label.action':
			return <LabelIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.add-comment.action':
			return <CommentIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'outgoing.email':
			return <EmailIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.restrict-page.action':
			return <LockIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.change-page-owner.action':
			return <PersonIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.copy-page.action':
			return <CopyIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.move-page.action':
			return <RightArrowIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.update-data-classification.action':
			return <ShieldIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'jira.issue.create':
			return <JiraIcon size="small" label="" appearance="brand" />;
		case 'confluence.generate-ai-summary.action':
		case 'confluence.generate-ai-action-items.action':
			return (
				<AtlassianIntelligenceIcon
					testId="atlassian-intelligence-icon"
					label=""
					color={getPrimaryColor(ComponentType.ACTION)}
				/>
			);
		case 'confluence.create-database.action':
			return <DatabaseIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.create-whiteboard.action':
			return <WhiteboardIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'confluence.create-folder.action':
			return <FolderIcon label="" color={getPrimaryColor(ComponentType.ACTION)} />;
		case 'rovo.invoke-agent.action':
			return <RovoIcon size="small" label="" appearance="brand" />;
	}
};
